import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import backGroundSvg from '../../../images/loginBackSvg.svg'
import ResetPasswordImage from '../../../images/firstTimePassword.svg'
import Form from './Form'
import Success from './Success'
import { userAuthResetAlertHandler, validateResetPasswordToken } from '../../../redux/features/userAuth/userAuthThunk'
import ExpiredLink from './ExpiredLink'
import { selectAuthUser } from '../../../redux/features/userAuth/userAuthSlice'
import LoaderWithErrorHandler from '../../../components/PageHelpers/LoaderWithErrorHandler'

const ResetPassword = () => {
  const [resetPasswordSuccess, setResetPasswordSuccess] = useState(false)
  const [expireLink, setExpireLink] = useState(false)
  const dispatch = useDispatch()
  const { token } = useParams()
  const userAuth = useSelector(selectAuthUser)

  useEffect(() => {
    dispatch(validateResetPasswordToken({ queries: token })).then((res) => {
      if (res?.meta?.requestStatus !== 'fulfilled') {
        setExpireLink(true)
      }
    })
  }, [])

  return (
    <>
        {expireLink ? <ExpiredLink /> : (
    <Box sx={styles.root}>
      <Box sx={styles.loginContainer}>
          {
            resetPasswordSuccess ? (<Success/>)
              : (<Form setResetPasswordSuccess={setResetPasswordSuccess} token={token}/>)
          }
            <Box component={'img'} sx={styles.rightImage} src={ResetPasswordImage} />
          </Box>

          </Box>

        )}
<Box component={'img'} sx={styles.backSvg} src={backGroundSvg} />
        <LoaderWithErrorHandler store={userAuth}
        resetAlertHandler={userAuthResetAlertHandler} />
</>
  )
}
const styles = {
  root: {
    '& header': {
      marginBottom: '0px',
    },
  },
  loginContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: { xs: 'column-reverse', md: 'row' },
    position: 'relative',
    maxHeight: { xs: '80vh', sm: '90vh' },
    px: { xs: '10px', sm: '30px' },
    my: { xs: '30px', md: '0px' },
  },
  backSvg: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -10,
    objectFit: 'cover',
  },
  rightImage: {
    position: 'relative',
    zIndex: '8',
    my: { xs: '10px', md: '30px' },
    display: { xs: 'none', md: 'block' },
    width: { xs: '100%', sm: '300px', md: '400px', lg: '600px' },
    height: { xs: '250px', sm: '100%', md: '400px', lg: '500px' },
    mt: '20px',
  },
}

export default ResetPassword
